import axios from 'axios'
import { CHAT_ENDPOINTS } from '../config/chatEndpoints'

export const submitChatRecord = async (payload) => {
  const response = await axios.post(CHAT_ENDPOINTS.submitRecord, payload)

  return response.data
}